export default __webpack_public_path__ + "399fc6c6cd6992de0308914246ad7265.svg";